import React from 'react'


// MAHDOLLISESTI APUJA: https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array/2450976#2450976

// selkeämpi täällä: https://www.programiz.com/javascript/examples/get-random-item

export function getRandomItem(arr) {

    // get random index value
    const randomIndex = Math.floor(Math.random() * arr.length);

    // get random item
    const item = arr[randomIndex];

    return item;
}


export const removeItemFromArray = (arr, nro) => {
    let index = arr.indexOf(nro)
    if (index > -1) {
        arr.splice(index, 1);
    }

    return arr

}


export const shufflaa = (optiot) => {
    let n = optiot.length
    let oldOrderTable = []
    let newOrderTable = []

    for (let i = 0; i < n; i++) {
        oldOrderTable.push(i)
    }
    let res
    for (let i = 0; i < n; i++) {
        res = getRandomItem(oldOrderTable)
        newOrderTable.push(res)
        oldOrderTable = removeItemFromArray(oldOrderTable, res)
    }

    let newOptiot = []

    for (let i = 0; i < optiot.length; i++) {
        const obj = optiot[newOrderTable[i]]
        newOptiot.push(obj)
    }

    return newOptiot
}

export const shufflaaKuvat = (order2, i, arr) => {

    //toimii tässä muodossa vain jos arr sis 4 alkiota (kuvaa)
    let sKuva
    let kuva_id
    if (order2[i] == 1) {
        sKuva = arr[0]
        kuva_id = 1
    }
    else if (order2[i] == 2) {
        sKuva = arr[1]
        kuva_id = 2
    }
    else if (order2[i] == 3) {
        sKuva = arr[2]
        kuva_id = 3
    }
    else if (order2[i] == 4) {
        sKuva = arr[3]
        kuva_id = 4
    }
    return [sKuva, kuva_id]

}


